import { normalizeLocale } from './normalize'

const bootstrapLocales = ['ru', 'en', 'kk', 'az', 'uk', 'uz', 'ky', 'tr', 'hi']
const applicationLocales = [...bootstrapLocales, 'es']
const profileLocales = [...bootstrapLocales, 'bn', 'es']

export function readLocaleSettings({ stage = 'application' } = {}) {
  const configuredLocales = String(process.env.LOCALES || '')
    .split('|')
    .filter(Boolean)
  return {
    platform: process.env.PLATFORM,
    webview: process.env.WEBVIEW === '1',
    configuredLocales,
    availableLocales: configuredLocales.length
      ? configuredLocales
      : [...(stage === 'bootstrap' ? bootstrapLocales : applicationLocales)],
    profileLocales: configuredLocales.length ? configuredLocales : [...profileLocales],
    defaultLocale: process.env.DEFAULT_LANG || 'en',
    baseUrl: process.env.BASE_URL || '',
  }
}

export function createLocaleContext({ settings, policy, urlLocale = null, region = null, environment }) {
  const storedRaw = environment.storage.getItem(policy.storage.key)
  return {
    ...settings,
    urlLocale,
    storedLocale:
      normalizeLocale(policy.storage.deserialize(storedRaw), settings.availableLocales) ||
      (policy.storage.fallbackKey
        ? normalizeLocale(environment.storage.getItem(policy.storage.fallbackKey), settings.availableLocales)
        : null),
    languages: environment.navigator.languages,
    language: environment.navigator.language,
    isBot: environment.isBot,
    region,
  }
}
